module.exports = __webpack_public_path__ + "img/Unkown File.7fb5f2c1.svg";